import { z } from 'zod'

export const callFormSchemaZ = z.object({
  fullname: z.string().trim().min(1, {
    message: 'To pole jest wymagane'
  }),
  phoneNumber: z
    .string()
    .regex(
      /(?<!\w)(\(?(\+|00)?48\)?)?[ -]?\d{3}[ -]?\d{3}[ -]?\d{3}(?!\w)/,
      'Podaj poprawny numer telefonu.'
    ),
  message: z.string().trim().min(1, {
    message: 'To pole jest wymagane'
  }),
  acceptTerms: z.boolean().refine(val => val, {
    message: 'Zgoda jest wymagana'
  })
})

export type CallFormSchema = z.infer<typeof callFormSchemaZ>
